import React, { Fragment, useEffect, useState } from 'react';
import Navbar from '../layouts/Navbar';
import Footer from '../layouts/Footer';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';

const Testimony = ()=>{
    const uri = useSelector(state=>state.uri)
    const [testimonies, setTestimonies] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [arr,] = useState([1,2,3])

    useEffect(()=>{
        axios.get(
            `${uri}testimonies`
        ).then(res=>{
            setTestimonies(res.data.data)
            setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)
            // setError(err.message)
        })
    }, [uri])
    return (
        <Fragment>
            <Navbar />
            <div className='mt-5 pt-5 container'>
            <div className='d-flex justify-content-center'>
                <div className='col-md-6'>
                    <p className='text-yrh text-center fw-bold fs-4 my-0'>What our members are saying</p>
                    <hr className='my-0 text-line' />
                </div>
            </div>
            {
                isLoading
                ?
                <div className='mt-5 container'>
                    <div className='row my-5'>
                        {
                            arr.map((each, i)=>(
                                <div key={i} className='col-md-4 mb-4' data-aos='fade-up'>
                                    <div className='card testimonies bg-yrh text-white rounded-3 px-2 pt-5'>
                                        <div className='testimony-body'>
                                            <Skeleton className='bg-light w-100' variant='text' />
                                        </div>
                                        <div className='d-flex pt-3 pb-3'>
                                            <div>
                                                <Skeleton className='bg-light' variant='circular' width={40} height={40} />
                                            </div>
                                            <div className='ms-2'>
                                                <Skeleton className='bg-light' width={200} variant='text' />
                                                <Skeleton className='bg-light w-100' variant='text' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                :
                testimonies.length !== 0
                ?
                <>                    
                    <div className='row my-5'>
                        {
                            testimonies.map((each, i)=>(
                                <div key={i} className='col-md-4 mb-4' data-aos='fade-up'>
                                    <div className='card testimonies bg-yrh text-white rounded-3 px-2 pt-5'>
                                        <div className='testimony-body'>
                                            <p className='pt-3'>
                                                {each.testimony}
                                            </p>
                                        </div>
                                        <div className='d-flex pt-3 pb-3'>
                                            <div>
                                                <div className='p-2 text-dark fw-bold rounded-circle bg-footer'>
                                                    {each.fullname.split(' ')[0][0]}.{each.fullname.split(' ')[1][0]}
                                                </div>
                                            </div>
                                            <div className='ms-2'>
                                                <p className='text-white my-0'>{each.fullname}</p>
                                                <p className='fst-italic text-testimony'>{each.dept}, {each.level}L</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </>
                :
                <div className='mt-5 container'>
                    <p className='fs-5 text-yrh fst-italic pb-5'>
                        This page is currently unavailable, check back later...
                    </p>
                </div>
            }
            </div>
            <Footer />
        </Fragment>
    )
}

export default Testimony